export const promotionBanner = 'promotion_banner'

export const simplifiedCardTitle = 'simplified_card_title'

export const inviteTravelCrew = 'invite_travel_crew'

export const googleAuthentication = 'google_authentication'
